/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/CreditsDialog',['Solitaire/MvvmStructure/Service/NewsService', 'util/SettingsManager', 'absolute/stringmanager'],
    function (NewsService, SettingsManager, _s) {
        "use strict";

        var CreditsDialog = function () {
            this.initCreditsData();
            this.initCreditsDialog();
            this.initScrollHandlers();
        };

        CreditsDialog.prototype.initCreditsData = function () {
            var creditsElement = document.getElementById('credits'),
                creditsHtml = creditsElement.innerHTML,
                labelKeys = creditsHtml.match(/{(.*)}/g).map(function(r) {
                    return r.match(/\{.(.*?)\}/)[1]
                });
            creditsElement.innerHTML = labelKeys
                .reduce(function (text, l) {
                    return text.replace('{{' + l + '}}', _s('credits.' + l))
                }, creditsHtml);
            document.getElementById('closeCredits').innerHTML = _s('buttons.close');
        };

        CreditsDialog.prototype.initCreditsDialog = function () {
            this.overlayContainer = document.getElementById("overlayContentWrapper");
            this.credits = document.getElementById("credits");
            this.creditsOverlay = document.getElementById("htmlBoxOverlay");
            this.creditsCloseButton = document.getElementById("closeCredits");
            this.creditsCloseButton.onmouseup = this.creditsCloseButton.ontouchend = function () {
                this.hide();
                event.preventDefault();
            }.bind(this);
        };

        CreditsDialog.prototype.show = function (closeCallback) {
            this.overlayContainer.style.display = "block";
            this.credits.style.display = "block";
            this.creditsOverlay.style.display = "block";
            this.closeCallback = closeCallback;
        };

        CreditsDialog.prototype.hide = function () {
            this.overlayContainer.style.display = "none";
            this.credits.style.display = "none";
            this.creditsOverlay.style.display = "none";
            if (typeof this.closeCallback === 'function') {
                this.closeCallback();
            }
        };

        CreditsDialog.prototype.initScrollHandlers = function () {
            var $container = $('.creditsContent');
            var delta = 50;
            $(document).keydown(function (e) {
                if (e.keyCode == 38) {
                    $container.scrollTop($container.scrollTop() - delta);
                } else if (e.keyCode == 40) {
                    $container.scrollTop($container.scrollTop() + delta);
                }
            });

        };

        Object.defineProperty(CreditsDialog.prototype, "showing", {
            get: function () {
                return this.credits.style.display == "block";
            }
        });

        return CreditsDialog;

    });

